import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPage, { getDefaultPageUI } from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";

/**
 * @function CaptureMabiEDEStatementsMenuOpened
 * @param {OBJECT} props - None used for now.
 * @description - Component for capture "004_menu_opened" in mabi23 capture group "Statements".
 */
export default function CaptureMabiEDEStatementsMenuOpened(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "mobileMenu" ], { isActive: true })
    .submit();

    return <EDEStatementsPage ui={ ui } />
}